import qs from 'qs';
import { fetchApi, getOrganisationId, getUserId } from 'shared/functions';

export const fetchAnalysts = ({ query } = {}) => {
  const organisationId = getOrganisationId();
  const userId = getUserId();

  const params = {
    page: 1,
    start: 0,
    limit: 100,
    filter:
      '[{"property":"followed","direction":"DESC","priority":"1"},{"property":"firstName","direction":"ASC","priority":"2"},{"property":"name","direction":"ASC","priority":"3"}]',
    ...(query && { query }),
  };

  return fetchApi(
    `/sso/organisations/${organisationId}/users/${userId}/analysts?${qs.stringify(params)}`,
  ).then(response => response.json());
};
